export const RESPONSIVE_SMALL = 767;
export const RESPONSIVE_MEDIUM = 1024;
export const RESPONSIVE_LARGE = 1300;
export const RESPONSIVE_EXTRA_LARGE = 1600;
